import DeliverableCard from './components/DeliverableCard';
import type { Database } from '@/types/database.types';
type Project = Database['public']['Tables']['projects']['Row'];
import type { DeliverableWithTeam } from '.';
import type { ProjectRole } from '../../../../utils/status';

export default function VideosTab({
  deliverables,
  project,
  projectRole,
}: {
  deliverables: DeliverableWithTeam[];
  project: Project;
  projectRole: ProjectRole;
}) {
  const allDeliverables = deliverables.map((deliverable) => (
    <DeliverableCard
      deliverable={deliverable}
      project={project}
      projectRole={projectRole}
      key={deliverable.id}
    />
  ));

  return <div>{allDeliverables}</div>;
}
